let basePath = '';

export function setRouteBasePath(value: string): void {
	basePath = value;
}

export function route(path: string): string {
	return `${basePath}${path.startsWith('/') ? path : `/${path}`}`;
}

export function isRouteActive(pathname: string, path: string): boolean {
	const target = route(path);
	return pathname === target || pathname.startsWith(`${target}/`);
}
